<template>
  <div class="chat">
    <iframe src="https://livechat.connexease.com/embed/5d432f58-c1e6-4b09-b5ce-481421020719"></iframe>
  </div>
</template>

<script>
export default {
  name: 'Chat',
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .chat {

    iframe {
      height: 95vh;
      border: 0;
      width: 100%;
    }

    @media (min-height:600px) {
      iframe {
      height: 514px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Chat.vue?06fab6a2